import { Box } from "@mui/material";
import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { CMForm } from "../../components/common/Form/CMForm";
import { PageHeader } from '../../components/common/PageHeader/PageHeader';
import { addMedicine } from "./MedicinesServices";
import { validationSchema, formFields } from "./MedicinesSchema";
import MedicineTable from "../../components/common/Model/MedicineTable";

export const MedicinesAdd = () => {
    const AddDetails = (values: any) => {
           
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>

                    <Row>
                        <Col lg={12}>
                            <Box component="div" sx={{ mt: 2 }}>
                                <PageHeader header="Add Medicine" />
                                {/* <CMForm
                                    validationSchema={validationSchema}
                                    formFields={formFields}
                                    addService={addMedicine}
                                    listPageKey='MEDICINE_LIST'
                                /> */}
                                <MedicineTable/>
                            </Box>
                        </Col>
                    </Row>

                </Container>
            </div>
        </React.Fragment> 
        
      
    )
}
